import type { MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import {
    options_messageList_quick_showAsConversation,
    options_messageList_quick_showAsMessage,
} from 'owa-conversations-option/lib/components/ConversationsQuick.locstring.json';
import loc from 'owa-localize';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { getUserConfiguration } from 'owa-session-store';
import { onConversationModeClicked } from '../../util/commandActions';
import { createMailGeneratedMenuItem } from '../../util/createMailRibbonButton';

export default function getConversationsSections(): MenuSection[] {
    let sections: MenuItemControlProps[] = [];

    const options: { mode: ReactListViewType; label: string; keytip: string }[] = [
        {
            mode: ReactListViewType.Conversation,
            label: loc(options_messageList_quick_showAsConversation),
            keytip: 'C', // win32 is 'GC', but it's a checkbox there
        },
        {
            mode: ReactListViewType.Message,
            label: loc(options_messageList_quick_showAsMessage),
            keytip: 'M',
        },
    ];
    const modeSelected = getUserConfiguration().UserOptions?.GlobalListViewTypeReact;

    options.forEach(option => {
        sections.push(
            createMailGeneratedMenuItem(
                MailRibbonControlId.Conversations + '_' + option.mode,
                option.label,
                undefined /*tooltip*/,
                () => {
                    onConversationModeClicked(option.mode);
                },
                constructKeytip(
                    [
                        getKeytipString(MailRibbonTabId.Tab_View),
                        getKeytipString(MailRibbonControlId.Conversations),
                    ],
                    option.keytip
                ),
                option.mode === modeSelected
            )
        );
    });

    return [
        {
            controls: sections,
        },
    ];
}
